import React from 'react';
import styled from 'styled-components';
// import { useChat } from '../context/ChatProvider';
import { useChat } from '../../../context/provider/ChatProvider';
// import ChatContainer from './ChatContainer';
import ChatContainer from './ChatContainer';
// import Login from './Login';
import Login from './Login';

const WrapperContainer = styled.div`
    display: grid;
    height: 90vh;
`;

const Wrapper = () => {
    const { userName } = useChat();

    return (
        <div className='grid h-90vh  lg:flex-col lg:flex lg:border-red-500' >

            {
                <ChatContainer />
            }
        </div>
    );
};

export default Wrapper;